<template>
  <div class="consumptionHistory">
    <div>
      <div>支付成功后，请点击
        <a @click="getConsumptionHistory()" style="font-weight:700">&nbsp;更新</a>，
        获取您的下载地址。请勿多次扫码或点击余额进行支付，以免发生重复付费。重复付费以及支付成功后未能下载的，系统将在5个工作日内自动返还到您的余额中。
      </div>
      <el-row :gutter="20">
        <el-col :span="18">
          <div>您的标准及法规的下载地址，保留一年，在一年内，您可以多次重复下载。搜索结果的下载，仅保留一周，因为每周都有标准和法规的更新上线，为确保您获得最新的搜索结果。 搜索结果仅保留一周。</div>
        </el-col>
        <el-col :span="6" style="text-align:right">
          <button class='button' @click="getConsumptionHistory()">
            刷新支付状态
          </button>
        </el-col>
      </el-row>
    </div>
    <table class='table'>
      <tr>
        <th width="85%">已支付订单</th>
        <th width="15%">下载地址</th>
      </tr>
      <tr v-for="item in consumptionHistory" :key="item.code">
        <td>
          {{item.description}}
        </td>
        <td style="text-align:center;">
          <span v-if="item.url == '处理中'">
            处理中
          </span>
          <a v-else :href="item.url">
            <font-awesome-icon icon="arrow-alt-circle-down" />
          </a>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      table_height: Number
    },
    computed: {
      consumptionHistory() {
        if (this.$store.state.users.consumptionHistory == null) {
          return [];
        } else {
          return this.$store.state.users.consumptionHistory;
        }
      }
    },
    methods: {
      getConsumptionHistory() {
        this.$store.dispatch("users/getConsumptionHistory");
      }
    }
  };
</script>

<style scoped>
  .consumptionHistory {
    margin-top: 0.1rem;
    text-align: left
  }

  .consumptionHistory .button {
    background-color: #aa0000 !important;
    border: solid 0.01rem #efefef;
    border-radius: 0.05rem;
    color: #efefef;
    outline: none;
    text-align: center;
    text-decoration: none;
    letter-spacing: 0.01rem;
    display: inline-block;
    height: 0.5rem;
  }

  .consumptionHistory .button:hover {
    cursor: pointer;
    background-color: red !important;
  }
</style>
<style>
  .consumptionHistory .ivu-table-cell {
    padding: 0 0.05rem !important;
    word-break: keep-all;
  }



  .consumptionHistory table,
  .consumptionHistory td,
  .consumptionHistory th {
    border: 1px solid #ccc;
    border-collapse: collapse;
    padding: 0.03rem
  }

  .consumptionHistory table {
    width: 100%;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
  }

  .consumptionHistory th {
    background-color: #ddd;
    text-align: center;
    align-self: center
  }
</style>